import OrderOptimizerDetailsCargo, {
  OrderOptimizerDetailsCargoOptimizedStats,
  OrderOptimizerDetailsCargoOrders,
  OrderOptimizerDetailsCargoSteps,
  OrderOptimizerDetailsCargoStepsLastPoint,
  OrderOptimizerDetailsCargoStepsOrders,
  OrderOptimizerDetailsCargoStepsOrdersPoints,
  OrderOptimizerDetailsCargoUnoptimizedStats,
} from "../../../../../common/services/order-optimizer/details/cargo/order-optimizer-details-cargo";
import OrderOptimizerCargoDetailsItem, {
  OrderOptimizerCargoDetailsItemStepsOrdersPoints,
  OrderOptimizerCargoDetailsItemStepsOrders,
  OrderOptimizerCargoDetailsItemSteps,
  OrderOptimizerCargoDetailsItemOrders,
  OrderOptimizerCargoDetailsItemOptimizedStats,
  OrderOptimizerCargoDetailsItemUnoptimizedStats,
  OrderOptimizerCargoDetailsItemStepsLastPoint,
} from "./types/order-optimizer-cargo-details-item";

const createDetailsItemStepsOrderPoint = (
  stepsOrderPoint: OrderOptimizerDetailsCargoStepsOrdersPoints
): OrderOptimizerCargoDetailsItemStepsOrdersPoints => ({
  displayName: stepsOrderPoint.displayName,
  distance: stepsOrderPoint.distance,
  haltingTime: stepsOrderPoint.haltingTime,
  lat: stepsOrderPoint.lat,
  lon: stepsOrderPoint.lon,
  time: stepsOrderPoint.time,
});

const createDetailsItemStepsOrderPoints = (
  stepsOrderPoints: OrderOptimizerDetailsCargoStepsOrdersPoints[]
): OrderOptimizerCargoDetailsItemStepsOrdersPoints[] => {
  return stepsOrderPoints.map(createDetailsItemStepsOrderPoint);
};

const createDetailsItemStepsOrder = (
  stepsOrder: OrderOptimizerDetailsCargoStepsOrders
): OrderOptimizerCargoDetailsItemStepsOrders => ({
  distance: stepsOrder.distance,
  haltingTime: stepsOrder.haltingTime,
  points: createDetailsItemStepsOrderPoints(stepsOrder.points),
  totalTime: stepsOrder.totalTime,
});

const createDetailsItemStepsOrders = (
  stepsOrders: OrderOptimizerDetailsCargoStepsOrders[]
): OrderOptimizerCargoDetailsItemStepsOrders[] => {
  return stepsOrders.map(createDetailsItemStepsOrder);
};

const createDetailsItemStepsLastPoint = (
  stepsLastPoint: OrderOptimizerDetailsCargoStepsLastPoint | null
): OrderOptimizerCargoDetailsItemStepsLastPoint | null => {
  if (!stepsLastPoint) return null;
  return {
    displayName: stepsLastPoint.displayName,
    distance: stepsLastPoint.distance,
    haltingTime: stepsLastPoint.haltingTime,
    lat: stepsLastPoint.lat,
    lon: stepsLastPoint.lon,
    time: stepsLastPoint.time,
  };
};

const createDetailsItemSteps = (
  steps: OrderOptimizerDetailsCargoSteps
): OrderOptimizerCargoDetailsItemSteps => {
  return {
    lastPoint: createDetailsItemStepsLastPoint(steps.lastPoint),
    orders: createDetailsItemStepsOrders(steps.orders),
  };
};

const createDetailsItemOrder = (
  order: OrderOptimizerDetailsCargoOrders
): OrderOptimizerCargoDetailsItemOrders => ({
  billingModel: order.billingModel,
  distance: order.distance,
  haltingTime: order.haltingTime,
  humanId: order.humanId,
  startTime: order.startTime,
  taxiCorporation: order.taxiCorporation,
  totalTime: order.totalTime,
});

const createDetailsItemOrders = (
  orders: OrderOptimizerCargoDetailsItemOrders[]
): OrderOptimizerDetailsCargoOrders[] => {
  return orders.map(createDetailsItemOrder);
};

const createDetailsItemOptimizedStats = (
  optimizedStats: OrderOptimizerDetailsCargoOptimizedStats
): OrderOptimizerCargoDetailsItemOptimizedStats => {
  return {
    distance: optimizedStats.distance,
    haltingTime: optimizedStats.haltingTime,
    saving: optimizedStats.saving,
    totalTime: optimizedStats.totalTime,
  };
};

const createDetailsItemUnoptimizedStats = (
  unoptimizedStats: OrderOptimizerDetailsCargoUnoptimizedStats
): OrderOptimizerCargoDetailsItemUnoptimizedStats => {
  return {
    distance: unoptimizedStats.distance,
    haltingTime: unoptimizedStats.haltingTime,
    saving: unoptimizedStats.saving,
    totalTime: unoptimizedStats.totalTime,
  };
};

const createDetailsItem = (
  detailsItem: OrderOptimizerDetailsCargo
): OrderOptimizerCargoDetailsItem => {
  return {
    optimizedStats: createDetailsItemOptimizedStats(detailsItem.optimizedStats),
    orders: createDetailsItemOrders(detailsItem.orders),
    reviewedAt: detailsItem.reviewedAt,
    reviewedBy: detailsItem.reviewedBy,
    steps: createDetailsItemSteps(detailsItem.steps),
    unoptimizedStats: createDetailsItemUnoptimizedStats(
      detailsItem.unoptimizedStats
    ),
    score: detailsItem.score,
  };
};

const orderOptimizerCargoDetailsItemFactory = {
  createDetailsItem,
  createDetailsItemOrders,
};

export default orderOptimizerCargoDetailsItemFactory;
